
(function ($) {

    $(document).ready(() => {
        if (!!$('.country-picker-overlay').length) {
            // Country picker isn't included if the user is logged in so only do this if necessary

            $('.country-picker-button').click(() => onToggleCountryPicker(true));
            $('.country-picker-overlay .close-overlay').click(() => onToggleCountryPicker(false));
            $(".js-countrypicker-option").click(onOptionSelected);
            $('#country-picker-overlay-selection-screen .region-bar a[data-toggle="tab"]').keypress(onRegionKeypress);
            $('#country-picker-overlay-selection-screen .region-bar a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                let regionId = $(e.target).attr('data-region');
                setTabIndexes(regionId);
            })

            if (!$('.country-picker-overlay').hasClass('d-none')) setPageInert(true);
        }

        // Position the mobile menu bar correctly
        $(".internationalization-bar").css("top", `${window.innerHeight - $(".internationalization-bar").innerHeight()}px`);
        window.addEventListener("resize", () => {
            $(".internationalization-bar").css("top", `${window.innerHeight - $(".internationalization-bar").innerHeight() }px`);
        });
    });
    
    function onRegionKeypress(e) {
        let key = e.keyCode || e.which;
        if (key == 13 || key == 32) {
            $(e.target).closest('.nav-link').trigger('click');
        }
    }

    function onOptionSelected(e) {
        e.preventDefault();

        let selectedOption = $(e.target).closest(".js-countrypicker-option"); // Closest was added because google translate creates extra elements
        let countryCode = selectedOption.attr("data-country");
        let language = selectedOption.attr("data-language");

        let form = $(this).closest("form");
        form.find("input[name=countryCode]").val(countryCode);
        form.find("input[name=language]").val(language);

        let changeMarket = (clearCart) => {
            $('.js-clear-cart').val(clearCart);
            return new Promise((resolve, reject) => {
                $.ajax({
                    type: "POST",
                    url: form[0].action,
                    data: form.serialize(),
                    success: function (response) {
                        if (response.cart) {
                            console.log("the user has a cart");
                            $('#changeCurrency').modal({
                                show: true,
                                backdrop: 'static',
                            });
                            reject('failed');
                        }
                        else {
                            resolve(response);
                        }
                    }
                });
            });
        }

        changeMarket("false").then((response) => {
            document.location = response.returnUrl;
        })
            .catch(() => {
                $('.js-clear-cart').on('click', () => {
                    changeMarket("true").then((response) => {
                        document.location = response.returnUrl;
                    }).catch(() => { console.log("Error sending request with changeMarket(true).") })
                });
                $('.js-dismiss-change-currency').on('click', () => {
                    $field.val($field.data('previousVal'));
                });
            });
    }

    function onToggleCountryPicker(open) {
        if (open) {
            $('.country-picker-overlay').removeClass('d-none');
            $('body').addClass('noscroll');

            var activeRegionId = $('#country-picker-overlay-selection-screen .region-bar a.active').attr('data-region');
            setTabIndexes(activeRegionId);
            $(`#country-picker-overlay-selection-screen .region-bar a[data-region="${activeRegionId}"]`).focus();
        } else {
            setTabIndexes(-1);
            $('.country-picker-overlay').addClass('d-none');
            $('body').removeClass('noscroll');
        }
        setPageInert(open);
    }

    // Browsers don't set tabindexes for elements that are display:none on page load, so we have to manually set them when the overlay is opened
    function setTabIndexes(regionId) {
        //console.log("Set tab indexes for region: " + regionId);
        let tabIndex = 400;
        if (regionId >= 0) {
            $('#country-picker-overlay-selection-screen .region-bar a').each((i, e) => {
                tabIndex++;
                $(e).attr('tabIndex', tabIndex);
            });
            tabIndex++;
            $('#country-picker-overlay-selection-screen .close-overlay').attr('tabIndex', tabIndex);
        } else {
            $('#country-picker-overlay-selection-screen .region-bar a').each((i, e) => {
                $(e).attr('tabIndex', -1)
            });
            $('#country-picker-overlay-selection-screen .close-overlay').attr('tabIndex', -1);
        }

        $('#country-picker-overlay-selection-screen .options-wrapper a, #country-picker-overlay-selection-screen .options-wrapper button').each((i, e) => {
            tabIndex++;
            $(e).attr('tabIndex', -1);
        });

        if (regionId >= 0) {
            $(`#country-picker-overlay-selection-screen #region-${regionId}-content a, #country-picker-overlay-selection-screen #region-${regionId}-content button`).each((i, e) => {
                tabIndex++;
                $(e).attr('tabIndex', tabIndex);
            });

            // Focus the region header after all tab indexes are set
            $(`#country-picker-overlay-selection-screen .region-bar a[data-region="${regionId}"]`).focus();
        }
    }

    function setPageInert(isInert) {
        if (isInert)
            $('#header, #wrapper').attr('inert', '');
        else 
            $('#header, #wrapper').removeAttr('inert');
    }
})(window.jQuery);